import React from 'react';
import styles from './Progressbar.module.scss';

export const ProgressBar = ({
  progress,
  backgroundColor = '#e0374a',
  showProgressbadge = false,
  progressBadge,
}) => {
  return (
    <>
      <div className={styles.progressWrapper}>
        <div className={styles.progressTrack}>
          <div
            className={styles.progressFill}
            style={{
              width: `${progress}%`,
              backgroundColor: `${backgroundColor}`,
            }}
          />
        </div>

        {/* Placeholder for the icon/image sitting at the end of the bar */}
        {showProgressbadge && (
          <div className={styles.progressBadge}>
            <img src={progressBadge} alt="Progress badge image" />
          </div>
        )}
      </div>
    </>
  );
};
